import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import NotFound from "../../components/SharedModule/NotFound";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";

export default function BarCode() {
  const newHost = "https://estbn.com/EstbnNew/public";

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const [show, setShow] = useState(false);

  const [barcodeData, setBarcodeData] = useState({
    type: "",
    quantity: "",
  });

  const handleShow = () => {
    setBarcodeData({
      type: "",
      quantity: "",
    });
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const { productId, batchId } = useParams();

  const [batchData, setBatchData] = useState(null);

  const [barCodeTypes, setBarCodeTypes] = useState([]);

  const [barCodes, setBarCodes] = useState({
    data: [],
    current_page: 1,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
  });

  const getBatch = async () => {
    try {
      const response = await axios.get(
        `${newHost}/api/portal/stock_batches/${batchId}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      setBatchData(response.data.data.stock_batch);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getTypes = async () => {
    try {
      const response = await axios.get(`${newHost}/api/portal/barcode-types`, {
        headers: newHeaders,
      });
      console.log(response.data.data.barcode_types);
      setBarCodeTypes(response.data.data.barcode_types);
    } catch (error) {
      console.log(error.message);
    }
  };

  const onSubmitAddMainCatogiry = () => {
    const formData = new FormData();
    formData.append("stock_batch_id", batchId);
    formData.append("variation_id", productId);
    formData.append("type", barcodeData.type);
    formData.append("quantity", barcodeData.quantity);

    const url = `${newHost}/api/portal/batch-items`;

    axios
      .post(url, formData, {
        headers: newHeaders,
      })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message, { autoClose: 3000 });
        setShow(false);
        setBarcodeData({
          type: "",
          quantity: "",
        });
        getBatch();
        getBarCodes();
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const getBarCodes = async (page = 1) => {
    try {
      const response = await axios.get(
        `${newHost}/api/portal/batch-items?batch_id=${batchId}&page=${page}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response.data.data.batch_items);
      setBarCodes(response.data.data.batch_items);
    } catch (error) {
      console.log(error.message);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= barCodes.last_page) {
      getBarCodes(page);
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  useEffect(() => {
    if (show && batchData?.available_for_generation) {
      const defaultQuantity = batchData.available_for_generation;
      setBarcodeData({
        type: "C128",
        quantity: defaultQuantity,
      });
      setValue("quantity", defaultQuantity);
    }
  }, [show, batchData, setValue]);

  useEffect(() => {
    getTypes();
    getBatch();
    getBarCodes();
  }, []);

  useEffect(() => {
    if (show) {
      setBarcodeData({
        type: "C128",
        quantity: batchData?.available_for_generation,
      });
    }
  }, [show, batchData]);

  return (
    <>
      {/* generate batches */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="AddStaffModal_header">
          <Modal.Title className="AddStaffModal_title d-flex justify-content-between align-items-center">
            Generate Batch
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h5 className="mb-4">
              Available Quantity For Generation Is : {""}
              <span className="fs-5 text-muted">
                {batchData?.available_for_generation}
              </span>
            </h5>
          </div>
          <form onSubmit={handleSubmit(onSubmitAddMainCatogiry)}>
            <div className="row">
              {/* type  */}
              <div className="col-6">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="Type-label">Type</InputLabel>
                  <Select
                    labelId="Type-label"
                    label="Type"
                    {...register("type")}
                    value={barcodeData.type}
                    onChange={(e) => {
                      setBarcodeData({
                        ...barcodeData,
                        type: e.target.value,
                      });
                    }}
                  >
                    {barCodeTypes.map((type) => (
                      <MenuItem className="custom-menu-item" value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.type && <p className="danger">{errors.type.message}</p>}
              </div>
              {/* quantity */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  type="number"
                  label="Quantity"
                  placeholder="Enter Number"
                  variant="outlined"
                  slotProps={{
                    input: {
                      min: 1,
                      max: batchData?.available_for_generation ?? 1,
                    },
                  }}
                  {...register("quantity", {
                    required: "Quantity is required",
                    validate: (value) => {
                      const numValue = Number(value);
                      if (numValue < 1) return "Quantity must be at least 1";
                      if (numValue > batchData?.available_for_generation) {
                        return `Cannot exceed available quantity (${batchData?.available_for_generation})`;
                      }
                      return true;
                    },
                  })}
                  value={barcodeData.quantity}
                  onChange={(e) => {
                    const inputValue = Number(e.target.value);
                    setBarcodeData({
                      ...barcodeData,
                      quantity: inputValue,
                    });
                    // Update form value as well
                    setValue("quantity", inputValue, { shouldValidate: true });
                  }}
                />
                {errors.quantity && (
                  <p className="danger">{errors.quantity.message}</p>
                )}
              </div>

              {/* <div className="col-6">
                <TextField
                  className="w-100 mb-4"
                  type="number"
                  label="Quantity"
                  placeholder="Enter Number"
                  variant="outlined"
                  slotProps={{
                    input: {
                      min: 2,
                      max: batchData?.available_for_generation ?? 1,
                    },
                  }}
                  {...register("quantity", {
                    required: "Quantity is required",
                    validate: (value) => {
                      const numValue = Number(value);
                      if (numValue <= 0)
                        return "Quantity must be greater than 0";
                      if (numValue > batchData?.available_for_generation) {
                        return `Cannot exceed available quantity (${batchData?.available_for_generation})`;
                      }
                      return true;
                    },
                    onChange: (e) => {
                      const inputValue = Number(e.target.value);
                      const max = batchData?.available_for_generation ?? 1;
                      if (inputValue <= max) {
                        setBarcodeData({
                          ...barcodeData,
                          quantity: inputValue,
                        });
                      }
                    },
                  })}
                  value={barcodeData.quantity}
                />
                {errors.quantity && (
                  <p className="danger">{errors.quantity.message}</p>
                )}
              </div> */}
            </div>
            {/* footer  */}
            <div className="foterAddModel">
              <button
                type="button"
                className="closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* generate batches */}
      <div className="mx-4 my-3">
        {/* Header Section */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-3">
          <h3 className="mb-0">Generate batches</h3>
          <div className="d-flex flex-wrap gap-2">
            <button
              onClick={handleShow}
              className="btn btn-outline-secondary d-flex align-items-center"
            >
              <i className="fa-solid fa-barcode me-2"></i>Generate batches
            </button>
            <button className="btn btn-outline-secondary">
              <i className="fa-solid fa-print"></i>
            </button>
          </div>
        </div>
        {/* Data Section */}
        <div className="border rounded-3 p-3 shadow-sm">
          {/* Batch Data Section */}
          <div className="border rounded-3 p-4 mb-3 shadow-sm bg-light">
            <div className="row gy-3">
              {[
                { label: "Reference", value: batchData?.reference },
                { label: "Item Name", value: batchData?.variation?.sku },
                { label: "Supplier Name", value: batchData?.supplier?.name },
                {
                  label: "Supplier Branch",
                  value: batchData?.supplier_branch?.name,
                },
                { label: "Quantity", value: batchData?.quantity },
                {
                  label: "Available For Generation",
                  value: batchData?.available_for_generation,
                },
                {
                  label: "Unused Items",
                  value: batchData?.unused_batch_items_count,
                },
                { label: "Status", value: batchData?.stock_status },
                { label: "Import Date", value: batchData?.import_date },
                { label: "Expiration Date", value: batchData?.expiration_date },
                { label: "Purchase Price", value: batchData?.purchase_price },
                { label: "Selling Price", value: batchData?.selling_price },
              ].map((item, index) => (
                <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
                  <div>
                    <h6 className="fw-bold mb-1">{item.label}</h6>
                    <p className="text-muted mb-0">{item.value ?? "-"}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* Barcodes Section */}
          <div className="border rounded-3 p-3 mb-2 shadow-sm">
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 ">
              {barCodes.data.length > 0 ? (
                barCodes.data.map((item) => (
                  <div key={item.id}>
                    <div className="border rounded-3 p-3 h-100 text-center shadow-sm">
                      <h4 className="fw-bold">ESTBN</h4>
                      <p className="text-muted">{item.reference}</p>
                      <p className="text-muted">{item.variation?.sku}</p>
                      <p className="text-muted">
                        Price: {item.stock_batch?.selling_price} EGP
                      </p>
                      <div className="my-2 w-100" style={{ height: "40px" }}>
                        <img
                          src={`https://estbn.com/EstbnNew/public${item.barcode_image_path}`}
                          className="w-100 h-100 object-fit-contain"
                          alt={item.variation?.sku || "Barcode"}
                        />
                      </div>
                      <p className="text-muted">{item.barcode}</p>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center w-100"
                  style={{ minHeight: "300px" }}
                >
                  <NotFound paragraphText="No Barcodes yet. All your Barcodes will appear here once you get started." />
                </div>
              )}
            </div>
            {/* Pagination */}
            {barCodes.data.length > 0 && (
              <div className=" w-100 d-flex justify-content-center align-items-center">
                <nav className="mt-4">
                  <div
                    className="custom-scroll"
                    style={{
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      paddingBottom: "8px",
                    }}
                  >
                    <ul
                      className="pagination d-inline-flex mb-0"
                      style={{ gap: "4px", minWidth: "max-content" }}
                    >
                      <li
                        className={`page-item ${
                          !barCodes.prev_page_url && "disabled"
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            handlePageChange(barCodes.current_page - 1)
                          }
                          disabled={!barCodes.prev_page_url}
                        >
                          Previous
                        </button>
                      </li>

                      {Array.from({ length: barCodes.last_page }, (_, i) => (
                        <li
                          key={i}
                          className={`page-item ${
                            barCodes.current_page === i + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(i + 1)}
                          >
                            {i + 1}
                          </button>
                        </li>
                      ))}

                      <li
                        className={`page-item ${
                          !barCodes.next_page_url && "disabled"
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            handlePageChange(barCodes.current_page + 1)
                          }
                          disabled={!barCodes.next_page_url}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
